import DOMPurify from "dompurify"
import { Delta, diff, formatters } from "jsondiffpatch"

const htmlDiff = (left: any, right: any) => DOMPurify.sanitize(formatters.html.format(diff(left, right) as Delta, null) ) || "No Change"

export default htmlDiff